export default __webpack_public_path__ + "static/media/02.5562aa89.jpg";